import React from "react"
import { Paragraph } from "../../Components/Paragraph"
import Button from "../../Components/Button"
import { MultiStepFlowContainer } from "../../Components/MultiStepFlow"
import { useOutletContextPlanActions } from "../../hooks/useOutletContextPlanActions"
import { useOutletContextPlan } from "../../hooks/useOutletContextPlan"
import { useNavigate } from "react-router-dom"

/**
 * PlanComplete
 *
 * Confirmation page shown after the plan has been successfully sent.
 * This is the final step in the setup flow.
 */
const PlanComplete = () => {
  const { handleDownloadPlan } = useOutletContextPlanActions()
  const { student, plan } = useOutletContextPlan()
  const navigate = useNavigate()

  const handleBackToChecklist = () => {
    navigate(`/plan/${plan?.token}/checklist`)
  }

  const steps = [
    {
      id: "plan-complete",
      encouragement: "✅",
      encouragementClassName: "text-3xl",
      title: `${student?.first_name ? student.first_name + "'s" : "Your"} Plan is Complete!`,
      renderCustomContent: () => {
        return (
          <div className="mx-auto flex max-w-xl flex-col items-center justify-center gap-2 text-center">
            <Paragraph>
              This Mentor Circle Plan is complete! This is a huge milestone and you should be proud
              of the journey you and your student have taken.
            </Paragraph>
            <Paragraph>
              Keep the momentum going by downloading the plan below or starting a new plan for next
              year!
            </Paragraph>

            <div className="mt-6 flex w-full flex-col items-center gap-4">
              <Button
                type="button"
                onClick={handleDownloadPlan}
                variant="secondary-outline"
                width="w-64"
              >
                Download the Plan
              </Button>

            </div>
          </div>
        )
      },
    },
  ]

  return (
    <MultiStepFlowContainer
      steps={steps}
      stepId="plan-complete"
      fieldWidth="w-64 mx-auto"
      initialValues={{}}
      fieldContainerClassName="flex flex-col items-center"
      showProgress={false}
      completeButtonText="Back to Checklist"
      completeButtonProps={{
        className: "flex items-center justify-center gap-2",
        width: "w-64",
        beforeIcon: (
          <i className="fa-solid fa-angle-left absolute left-4 top-1/2 -translate-y-1/2 text-3xl"></i>
        ),
      }}
      onComplete={handleBackToChecklist}
    />
  )
}

export default PlanComplete